export default {
  ja:[
    "値段",
    "円",
    "状態",
    "アイデアを送るには、売買するための本人確認等が必要になります。",
    "ここからデータを登録してね！",
    "新品",
    "中古",
    "アイデアを送る",
  ],
  en: [
    "Price",
    "JPY",
    "State",
    "In order to send an idea, confirmation of the identity of the person to buy or sell is necessary.",
    "Please register data from here!",
    "Suggest an idea",
  ]
}
